export const generateDropoffTrackingNumber = () => {
    // Timestamp component (base36 for compactness)
    const timestampPart = Date.now().toString(36).toUpperCase();
    
    // Random component (4 characters)
    const randomPart = Math.random().toString(36).substring(2, 6).toUpperCase();
    
    // Sequence component (optional counter for same-ms collisions)
    const sequence = Math.floor(Math.random() * 999).toString().padStart(3, '0');
    
    return `Drop_off_${timestampPart}${randomPart}${sequence}`;
  }